<template>
  <div class="payHome">
    <a-layout>
      <div class="payDiv">
        <div class="page-listHeader">
          <img class="imageLogin" src="./image/logo.jpg" />
        </div>
        <div class="formTable">
          <div class="fomrLeft" v-if="lang === 'zh-CN'">
            <a-form style="width: 96%; margin: 0 auto">
              <a-form-item>
                <p class="pOne">线下支付</p>
                <p class="pTow">人民币汇款信息</p>
                <p class="pThree">
                  银行账户:&nbsp;&nbsp;4039&nbsp;&nbsp;7647&nbsp;&nbsp;7974
                </p>
                <p class="pThree">名称:&nbsp;&nbsp;杭州检诺信息科技有限公司</p>
                <p class="pThree">
                  开户行:&nbsp;&nbsp;中国银行杭州市余杭支行营业部
                </p>
              </a-form-item>
              <a-form-item>
                <p class="pThree">
                  银行账户:&nbsp;&nbsp;2010&nbsp;&nbsp;0021&nbsp;&nbsp;5741&nbsp;&nbsp;342
                </p>
                <p class="pThree">名称:&nbsp;&nbsp;杭州检诺信息科技有限公司</p>
                <p class="pThree">
                  开户行:&nbsp;&nbsp;浙江省农村信用社(联合社)临平支行
                </p>
              </a-form-item>
            </a-form>
          </div>
          <div class="fomrLeft-en" v-if="lang === 'en-US'">
            <a-form style="width: 96%; margin: 0 auto" v-if="lang === 'en-US'">
              <a-form-item>
                <p class="pOne">Bank Transfer</p>
                <p class="pTow">
                  TT/ Wire Transfer Bank Information is as below, USD:
                </p>
                <p class="pThree">BANK:BANK OF CHINA, YUHANG SUB-BRANCH</p>
                <p class="pThree">
                  BANK ADDRESS:&nbsp;&nbsp;1 CENTURY RD LINPING YUHANG HANGZHOU
                  ZHEJIANG P.R.CHINA
                </p>
                <p class="pThree">SWIFT CODE:&nbsp;&nbsp;BKCHCNBJ910</p>
              </a-form-item>
              <a-form-item>
                <p class="pThree">
                  BENEFICIARY A/C
                  NO:&nbsp;&nbsp;3792&nbsp;&nbsp;7647&nbsp;&nbsp;4983
                </p>
                <p class="pThree">
                  CUSTOMER NAME:&nbsp;&nbsp;HANGZHOU MINDERWORK CO.,LTD
                </p>
                <p class="pThree">
                  CUSTOMER ADDRESS:&nbsp;&nbsp;ROOM 201, 68-1 BAOJIAN ROAD,
                  LINPING STREET, YUHANG DISTRICT, HANGZHOU, CHINA, 311100.
                </p>
              </a-form-item>
            </a-form>
          </div>
          <div class="formRight">
            <a-form
              :form="form"
              @submit="handleSubmit"
              style="width: 96%; margin: 0 auto"
            >
              <a-form-item
                :label="title"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 17 }"
                class="upload"
              >
                <a-upload
                  :action="config.urlImg + urlName"
                  :fileList="fileListOne"
                  listType="picture-card"
                  @preview="handlePreviewOne"
                  @change="handleChangeOne"
                  :multiple="true"
                >
                  <div>
                    <a-icon type="plus" />
                  </div>
                </a-upload>
                <a-modal
                  :visible="previewVisibleOne"
                  :footer="null"
                  @cancel="handleCancel1"
                >
                  <img
                    alt="example"
                    style="width: 100%"
                    :src="previewImageOne"
                  />
                </a-modal>
                <p v-if="lang === 'en-US'">
                  1、files should be within 2M. (JPG/PNG)
                </p>
                <p v-if="lang === 'en-US'">
                  2. Please dont upload fake receipt, otherwise the payment will
                  not be admitted
                </p>
                <p v-if="lang === 'zh-CN'">1、2M以内，JPG/PNG格式</p>
                <p v-if="lang === 'zh-CN'">
                  2、请勿提供虚假凭证，否则认为支付失败。
                </p>
              </a-form-item>
              <a-form-item>
                <div>
                  <a-button
                    type="primary"
                    @click="handleSubmit"
                    v-if="lang === 'zh-CN'"
                  >
                    提交信息
                  </a-button>
                  <a-button
                    type="primary"
                    @click="handleSubmit"
                    v-if="lang === 'en-US'"
                  >
                    Submit
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
      <proof-model ref="proofModel"></proof-model>
    </a-layout>
  </div>
</template>
<script>
import proofModel from '../proofModel/index';
export default {
  data() {
    return {
      collapsed: false,
      defaultSelectedKeys: [],
      defaultOpenKeys: [],
      form: this.$form.createForm(this),
      data: {},
      user: {},
      lang: 'zh-CN',
      mb: '',
      outTradeNo: '',
      previewVisibleOne: false,
      urlName: '/hzwmj/media/fileUpload',
      previewImageOne: '',
      fileListOne: [],
      //1-套餐，2-订单
      dowtype: '',
      // 套餐id || 订单id
      dowId: '',
      //1-人民币, 美元2
      moneyType: '',
      title: '',
    };
  },
  components: {
    'proof-model': proofModel,
  },
  watch: {
    $route() {
      this.getUrl();
      this.getMenu();
    },
  },
  created() {
    // 获取页面路径信息
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
      // return theRequest;
    }
    // 类型 1-套餐，2-订单
    this.dowtype = theRequest.type;
    // 套餐id || 订单id
    this.dowId = theRequest.id;
    // 1-人民币, 美元2
    this.moneyType = theRequest.moneyType;
    // 获取当前用户信息
    this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    // 获取中英文
    const lan = JSON.parse(sessionStorage.getItem('lang')) || null;
    if (lan != null) {
      this.lang = lan;
      lan === 'en-US' ? (this.title = 'Upload') : (this.title = '上传凭证');
    }
    // 查询获取订单数据 || 套餐数据
    this.querDataList();
  },
  methods: {
    // 跳转路由
    goRouter(value) {
      this.$router.push(value);
    },
    //数据提交
    handleSubmit(e) {
      console.log(this.data.setmealEnname);
      console.log(e);
      event.preventDefault();
      console.log('====数据======', this.data);
      // 购买套餐线下支付
      if (this.dowtype === '1') {
        const filesId = this.onFileList();
        if (filesId !== '') {
          this.form.validateFields((err, values) => {
            if (!err) {
              console.log('=====数据====', values);
              console.log('=====图片====', this.fileListOne);
              const ordId = this.data.id;
              const ordIdNum = ordId + '';
              this.$nextTick(() => {
                this.$http
                  .post('/hzwmj/person-setmealpay/addSetMealPayRecord', {
                    //验证信息(客户编号（ID）)
                    personId: this.user.id,
                    //验证信息(套餐订单财务状态 1（线上付款）、2（线下付款）、3（待付款）)
                    setmealState: '2',
                    //验证信息(套餐编号)
                    orderId: ordIdNum,
                    //验证信息(套餐名称)
                    setmealName: this.data.setmealName,
                    setmealEnname: this.data.setmealEnname,
                    //验证信息(套餐编号)
                    setmealId: this.data.setmealId,
                    //验证信息(套餐类型)
                    setmealType: this.data.setmealType,
                    //验证信息(总次数（人天）)
                    setmealCount: this.data.setmealCount,
                    //验证信息(使用订单号)
                    setmealUseorder: this.data.setmealUseorder,
                    //验证信息(线上支付金额)
                    setmealOnlinepay:
                      this.moneyType === '1'
                        ? this.data.setmealOriginrmb
                        : this.data.setmealDiscountmy,
                    //验证信息(购买数量)
                    setmealPaycount: '1',
                    //验证信息(付款凭证)
                    setmealPayment: this.onFileList(),
                  })
                  .then((data) => {
                    if (data.code === 200) {
                      const buyData = data.data;
                      this.data = buyData;
                      console.log('=====buyData=====', buyData);
                      if (buyData === true) {
                        this.$message.success('上传附件成功');
                        this.$refs.proofModel.init();
                      } else {
                        this.$message.error('上传附件失败');
                      }
                    } else if (data.code === 900) {
                      this.$message.error(data.msg);
                    } else {
                      this.$message.error('系统异常');
                    }
                  })
                  .catch(() => {});
              });
            }
          });
        } else {
          this.$message.error('支付凭证未上传,请上传支付凭证!');
        }
      }
      // 购买订单线下支付
      if (this.dowtype === '2') {
        const filesId = this.onFileList();
        if (filesId !== '') {
          this.form.validateFields((err, values) => {
            if (!err) {
              console.log('=====购买订单线下支付数据====', this.data);
              console.log('=====图片====', this.onFileList());
              console.log(values);
              this.$nextTick(() => {
                this.$http
                  .post('/hzwmj/balance-record/addBalanceRecord', {
                    //关联人id
                    recordPerson: this.user.id,
                    //验证信息(套餐订单财务状态 1（线上付款）、2（线下付款）、3（待付款）)
                    setmealState: '2',
                    //订单号
                    orderId: this.data.orderId,
                    //收支日志1、收入 2、支出
                    recordDiary: '2',
                    //支付类型1、支付宝2、微信 3、银联 4、paypal 5、套餐 6、线下 7、平台 8、提现
                    recordType: '6',
                    //付款凭证
                    recordPayment: this.onFileList(),
                    //交易状态1、成功 2、失败
                    recordState: '2',
                    //交易金额
                    balanceLimit:
                      this.moneyType === '1'
                        ? this.data.orderServicechargermb
                        : this.data.orderServicechargeusd,
                    //交易金额类型1（人民币）、2（美金）
                    balanceType: this.moneyType,
                  })
                  .then((data) => {
                    if (data.code === 200) {
                      const buyData = data.data;
                      this.data = buyData;
                      console.log('=====buyData=====', buyData);
                      if (buyData === '保存成功') {
                        this.$message.success('上传附件成功');
                        this.$refs.proofModel.init();
                      } else {
                        this.$message.error('上传附件失败');
                      }
                    } else if (data.code === 900) {
                      this.$message.error(data.msg);
                    } else {
                      this.$message.error('系统异常');
                    }
                  })
                  .catch(() => {});
              });
            }
          });
        } else {
          this.$message.error('支付凭证未上传,请上传支付凭证!');
        }
      }
    },
    // 遍历生产订单上传附件的ID
    onFileList() {
      let file = [];
      const fileList = this.fileListOne;
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        fileList.forEach((value) => {
          console.log('value.response1', value.response);
          value.response !== undefined
            ? file.push(value.response.data.object.id)
            : file.push(String(value.uid));
        });
        return file.join(',');
      } else {
        return '';
      }
    },
    //  获取订单数据 || 套餐数据
    querDataList() {
      // 1-套餐，2-订单
      if (this.dowtype === '1') {
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('=====数据1====', values);
            console.log('=====图片====', this.fileListOne);
            this.$nextTick(() => {
              this.$http
                .get('/hzwmj/setmeal/detail', {
                  params: {
                    id: this.dowId,
                  },
                })
                .then((data) => {
                  if (data.code === 200) {
                    const buyData = data.data;
                    this.data = buyData;
                    console.log('=====buyData=====', buyData);
                  } else if (data.code === 900) {
                    this.$message.error(data.msg);
                  } else {
                    this.$message.error('系统异常');
                  }
                })
                .catch(() => {
                  console.log('===err===');
                });
            });
          }
        });
      }
      if (this.dowtype === '2') {
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('=====数据2====', values);
            console.log('=====图片====', this.fileListOne);
            this.$nextTick(() => {
              this.$http
                .get('/hzwmj/workorder/getOrderBasic', {
                  params: {
                    id: this.dowId,
                  },
                })
                .then((data) => {
                  if (data.code === 200) {
                    const buyData = data.data;
                    this.data = buyData;
                    console.log('=====buyData=====', buyData);
                  } else if (data.code === 900) {
                    this.$message.error(data.msg);
                  } else {
                    this.$message.error('系统异常');
                  }
                })
                .catch(() => {
                  console.log('===err===');
                });
            });
          }
        });
      }
    },
    handleCancel1() {
      this.previewVisibleOne = false;
    },
    // 删除营业执照
    handlePreviewOne(file1) {
      this.previewImageOne = file1.url || file1.thumbUrl;
      this.previewVisibleOne = true;
    },
    // 上传营业执照
    handleChangeOne({ fileList }) {
      let list = [...fileList];
      // 从响应读取并显示文件链接
      list = list.map((file) => {
        if (file.response) {
          // 组件将file.url显示为链接
          file.url = file.response.url;
        }
        return file;
      });
      console.log('======list==', list);
      this.fileListOne = list;
    },
  },
};
</script>

<style lang="less">
.payHome {
  background-color: #ffffff;
  height: 100%;
  .page-spa {
    background-color: rgba(39, 86, 138, 1);
  }
  .ant-breadcrumb {
    display: inline;
  }
  .payDiv {
    position: relative;
    .page-listHeader {
      height: 280px;
      background-image: url(../../components/weChatPayment/image/header.jpg);
      .imageLogin {
        top: 20px;
        width: 300px;
        margin-top: 60px;
      }
    }
    .formTable {
      position: absolute;
      background-color: #ffffff;
      top: 70%;
      left: 10%;
      width: 80%;
      height: 600px;
      border: 1px solid #d2d1d1;
      /*box-shadow: 0 0 4px 2px #d2d1d1;*/
      box-shadow: 0 2px 12px 0 #e1e2e2;
      border-radius: 10px;
      .urlImage {
        width: 400px;
        padding-bottom: 80px;
      }
      .fomrLeft-en {
        display: inline-block;
        width: 50%;
        margin-right: 100px;
        .product-image {
          width: 220px;
        }
        .pOne {
          /*width: 90px;*/
          padding-top: 40px;
          font-size: 20px;
          font-weight: 500;
          top: 41px;
          margin-right: 220px;
          color: #00baad;
        }
        .pTow {
          text-align: left;
          font-size: 15px;
          font-weight: 800;
        }
        .pThree {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
        }
      }
      .fomrLeft {
        display: inline-block;
        width: 24%;
        margin-right: 100px;
        .product-image {
          width: 220px;
        }
        .pOne {
          width: 90px;
          padding-top: 40px;
          font-size: 20px;
          font-weight: 500;
          top: 41px;
          margin-right: 220px;
          color: #00baad;
        }
        .pTow {
          text-align: left;
          font-size: 15px;
          font-weight: 800;
        }
        .pThree {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
        }
      }
      .formRight {
        display: inline-block;
        bottom: 20px;
        width: 360px;
        .upload {
          p {
            font-size: 12px;
            /*margin-bottom: 0;*/
            line-height: 28px;
          }
        }
        .ant-upload-list-picture-card .ant-upload-list-item {
          width: 100%;
          height: 150px;
          padding: 2px;
          margin: 0px;
        }
        .ant-upload.ant-upload-select-picture-card {
          width: 100%;
          height: 150px;
          // padding: 2px;
          margin: 0px;
        }
        .ant-upload-select-picture-card i {
          font-size: 32px;
          color: #999;
        }
        .ant-upload-select-picture-card .ant-upload-text {
          margin-top: 8px;
          color: #666;
        }
      }
    }
  }
  overflow: hidden;
  .logo {
    width: 200px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 5px 0 5px 0;
    float: left;
    background-size: 200px 60px;
    background-repeat: no-repeat;
  }
}
</style>
